import React from "react";
import { getBrokerPartnerRefundSignupParagraphs } from "legal/brokerPartnerRefundSignupText";

/**
 * Refund eligibility + broker verification copy (no hyperlinks — URLs as plain text only).
 * Wording is sourced from `getBrokerPartnerRefundSignupParagraphs()` in `src/legal/brokerPartnerRefundSignupText.js`.
 */
export default function BrokerPartnerRefundNotice({
  variant = "full",
  className = "",
}) {
  const lines = getBrokerPartnerRefundSignupParagraphs();
  const [intro, ...rest] = lines;
  const verificationHeading = rest[0];
  const verificationLines = rest.slice(1);
  const compact = variant === "compact";

  return (
    <div
      className={`rounded-2xl border border-brand-400/25 bg-brand-500/[0.08] p-5 sm:p-6 ${className}`}
    >
      <h2
        className={`font-semibold text-brand-200 ${
          compact ? "text-base" : "text-lg"
        }`}
      >
        Broker partner requirement for refunds
      </h2>
      <p
        className={`mt-2 leading-relaxed text-gray-200 ${
          compact ? "text-xs sm:text-sm" : "text-sm sm:text-base"
        }`}
      >
        {intro}
      </p>

      {!compact && verificationHeading && (
        <>
          <h3 className="mt-4 text-sm font-semibold text-white">
            {verificationHeading}
          </h3>
          <ul className="mt-2 space-y-2 text-sm leading-relaxed text-gray-300">
            {verificationLines.map((line) => (
              <li key={line} className="break-words">
                • {line}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
